import dayjs from "dayjs";

import { formatCurrency } from "@/helpers/currency-helpers";
import { IListPrice } from "@/interfaces/list-price.interface";

type UseListPriceDataReturn = IListPrice & {
  isActive: boolean;
  formattedMainPrice: string;
  formattedPromoPrice: string;
  formattedStartPromoPrice: string;
  formattedEndPromoPrice: string;
  formattedStock: string;
};

function useListPriceData(listPrice: IListPrice): UseListPriceDataReturn {
  const isActive = listPrice?.active || false;
  const mainPrice = Number(listPrice?.mainPrice) || 0;
  const promoPrice = Number(listPrice?.promoPrice) || 0;
  const startPromoPrice = listPrice?.startPromoPrice ? new Date(listPrice?.startPromoPrice) : null;
  const endPromoPrice = listPrice?.endPromoPrice ? new Date(listPrice?.endPromoPrice) : null;
  const stock = Number(listPrice?.stock) || 0;

  const formattedMainPrice = formatCurrency(mainPrice, "pt-BR", "BRL");
  const formattedPromoPrice = formatCurrency(promoPrice, "pt-BR", "BRL");
  const formattedStartPromoPrice = startPromoPrice
    ? dayjs(startPromoPrice).format("DD/MM/YYYY")
    : "";
  const formattedEndPromoPrice = endPromoPrice ? dayjs(endPromoPrice).format("DD/MM/YYYY") : "";
  const formattedStock = formatCurrency(stock, "pt-BR", "BRL");

  return {
    ...listPrice,
    isActive,
    formattedMainPrice,
    formattedPromoPrice,
    formattedStartPromoPrice,
    formattedEndPromoPrice,
    formattedStock,
  };
}

export default useListPriceData;
